import { useScrollToQueryElement } from "../hooks/useScrollToQueryElement";
import { servicesItems } from "../data/services";
import { useState } from "react";
import { useAppStore } from "../store/useAppStore";
import { t } from "../utils/utils";

function FeatureItem({ item, selected, handleClick }) {
  const isSelected = selected.includes(item.id);
  return (
    <div
      className={`item ${isSelected ? "selected" : ""}`}
      id={item.id}
      onClick={() => handleClick(item.id)}
    >
      <div className="serviceHead">
        <img className="mainImg" src={item.img} alt={item.title} />
        <div className="head2">{item.title}</div>
      </div>
      <div className="textBlock">
        <div className="text2">
          {item.shortText}
          {isSelected && (
            <span className="fullText">&nbsp;{item.fullText}</span>
          )}
        </div>
      </div>
    </div>
  );
}

export function Services() {
  useScrollToQueryElement(true);
  const { appLang } = useAppStore();

  const [selected, setSelected] = useState([]);

  function handleClick(id) {
    setSelected((prev) => {
      if (prev.includes(id)) return prev.filter((el) => el !== id);
      return [...prev, id];
    });
  }

  return (
    <>
      <div className="features cont1" id="sole_trader">
        <div className="featuresHead">
          <div className="name">{t.services}</div>
          <div className="head1">{t.soleTrader}</div>
        </div>
        <div className="featuresCont">
          {servicesItems[appLang].services.map((el) => (
            <FeatureItem
              item={el}
              handleClick={handleClick}
              selected={selected}
              key={el.id}
            />
          ))}
        </div>
      </div>

      <div className="features cont1" id="limited_company">
        <div className="featuresHead">
          <div className="name">{t.services}</div>
          <div className="head1">{t.limitedCompanies}</div>
        </div>
        <div className="featuresCont">
          {servicesItems[appLang].limitedCompany.map((el) => (
            <FeatureItem
              item={el}
              handleClick={handleClick}
              selected={selected}
              key={el.id}
            />
          ))}
        </div>
      </div>

      <div className="features cont1" id="partnership">
        <div className="featuresHead">
          <div className="name">{t.services}</div>
          <div className="head1">{t.partnership}</div>
        </div>
        <div className="featuresCont">
          {servicesItems[appLang].pertnership.map((el) => (
            <FeatureItem
              item={el}
              handleClick={handleClick}
              selected={selected}
              key={el.id}
            />
          ))}
        </div>
      </div>
    </>
  );
}
